import React, {Component} from 'react';
import * as api from '../../api';
import * as qs from "query-string";
import { Grid, Popup, Segment} from 'semantic-ui-react';
import 'semantic-ui-css/semantic.min.css';
import { withRouter} from "react-router-dom";
import throttle from 'lodash/throttle';
import MapComponent from '../../components/map/map'
import YearlyDonutChart from "../../components/charts/custom/yearly-donut-chart";
import {Helmet} from "react-helmet";
import SiteTableHeader from './site-table-header';
import SiteTableRow from './site-table-row';
import SiteFundTableHeader from './sitefund-table-header';
import SiteFundTableRow from './sitefund-table-row';
import {collateUtilityData, defaultUtilities, sumUtilityData,sumUtilityDataDonut} from "../../helpers/chart-dataset-helpers";
import MonthlyUtilityChart from "../../components/charts/custom/monthly-utility-chart";
import ConsumptionChart from "../../components/charts/custom/consumption-chart";
import ApiDataProvider from "../../components/table/data-providers/api-data-provider";
import FilterableDatatable from "../../components/table/filterable-data-table";
import ReactGA from 'react-ga';
import AddSiteModel from './site-add';
import {AuthService} from "../../services/auth-service";
import { BreadcrumbContext } from '../../components/header/breadcrumbcontext'; // Adjust the path as necessary


class Sites extends Component {
    static contextType = BreadcrumbContext;

    constructor(props) {
        super(props);
        this.authServices = new AuthService();
        this.stickyRef = React.createRef();
        this.checkSticky = this.checkSticky.bind(this);

        this.state = {
            dataProvider: new ApiDataProvider(api.getSitesList, [this.props.customerId]),
            params: qs.parse(this.props.location.search),
            dataCompleteness: {},
            sitesList: [],
            monthlyCost: [],
            monthlyConsumption: [],
            yearlyCost: {},
            yearlyConsumption: {},
            yearlyConsumptionDonut: {},
            advancedFilters:[],
            uploadStatusList: ["error1", "error2"],
            downloadingFile : false,
            meterModalOpen : false,
            showErrorHide : true,
            showSuccessHide : true,
            changeDate : '',
            selectedRowKey: '',
            isSticky: false,
            hasScrolled: false
        };
    }

    checkSticky = () => {
        if (this.stickyRef.current) {
            const stickyTop = this.stickyRef.current.getBoundingClientRect().top;
            const windowHeight = window.innerHeight;
            const threshold = windowHeight * 0.3; // 30% of the viewport height
    
            const shouldBeSticky = stickyTop <= threshold;
    
            if (shouldBeSticky !== this.state.isSticky) {
                this.setState({ 
                    isSticky: shouldBeSticky,
                    shouldHideSecondRow: shouldBeSticky
                });
            }
        }
    };
    

    render() {

        const stickyGraphStyle = {
            position: 'sticky',
            top: '50px',
            zIndex: 100,
            backgroundColor: 'white',
            padding: '10px',
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
            display: this.state.isSticky ? 'flex' : 'none',
            transition: 'all 0.3s ease-in-out' // Add smooth transition
        };
    
       

        return (
            <div className='main-container'>
                <Helmet>
                    <title>Inenco Portal | Sites</title>
                </Helmet>
                <Grid padded stackable columns='equal' >
                    <Grid.Row >
                    {this.state.params.meterReadMode !== undefined ?
                        <Grid.Column>
                            <h2>Upload meter read for a single site</h2>
                        </Grid.Column>
                                    : 
                        <Grid.Column>
                            <h2>Sites</h2>
                        </Grid.Column>
    }
                    </Grid.Row>
                    {this.state.params.meterReadMode !== undefined ?
                     <div>
                    
                     <Segment inverted color='blue'>
                     To submit your meter reads, please use the available search options to find the site you require. Once you&apos;ve found it, 
                     click to view the site details and use manage my meter reads to submit your reads. You can also submit for individual meters by clicking meter details once you are viewing the site
                     
                     </Segment>
                    
                   </div>
                    :
                   
                   
                   <>

{/* LG INSTRUCTIONS - Initially HIDE THIS grid.row on load....Show only when <div className="table-container"> is at the top of the screen.,,, */}

                    <Grid.Row style={stickyGraphStyle}>
                        <Grid.Column>
                            {!!this.state.monthlyCost.length>0  && <MonthlyUtilityChart size={"compress"}
                                                             selectedRowKey={this.state.selectedRowKey}
                                                             data={this.state.monthlyCost} label={"Total Cost (£)"} title={"Monthly Utility Cost"} /> }
                        </Grid.Column>

                        <Grid.Column>
                            {!!this.state.monthlyCost.length>0  && <ConsumptionChart data={this.state.monthlyConsumption} size={"compress"}
                                                             selectedRowKey={this.state.selectedRowKey}
                                                             /> }
                        </Grid.Column>

                        <Popup content='PLEASE NOTE -  this graph is created based on calculations for expected dates of 
                        invoice delivery to Inenco and upload to our database. Therefore the graph/s may not show the full last 
                        12 months of data-completeness. (e.g. a series line with quarterly supplier billing may be 
                        “missing” up to 3 months backwards from today’s date – this will still be deemed to be 100% data-complete).'  
                        position='left center' 
                        inverted 
                        trigger={
                        <Grid.Column>
                            {!!this.state.dataCompleteness.length > 0 &&
                             <MonthlyUtilityChart data={this.state.dataCompleteness} size={"compress"}
                                 title={"Data Completeness By Utility"} label={"Percentage Complete (%)"}
                                 selectedRowKey={this.state.selectedRowKey}

                             />
                            }
                        </Grid.Column>
                        }/>



                        <Grid.Column>
                            {!!(this.state.yearlyCost.electricity > 0 || this.state.yearlyCost.gas > 0 || this.state.yearlyCost.water > 0) &&
                            <YearlyDonutChart data={this.state.yearlyCost} size={"compress"}
                            selectedRowKey={this.state.selectedRowKey}

                                              title={"Meter Sites Cost By Utlity (£) "}/>}
                        </Grid.Column>
                        <Grid.Column>
                            {!!(this.state.yearlyConsumptionDonut.electricity > 0 || this.state.yearlyConsumptionDonut.gas > 0 || this.state.yearlyConsumptionDonut.water > 0) &&
                            <YearlyDonutChart data={this.state.yearlyConsumptionDonut} size={"compress"}
                              
                                selectedRowKey={this.state.selectedRowKey}
                            title={"Meter Sites Consumption By Utility (kWh)"}/>}
                        </Grid.Column>
                    </Grid.Row>

                    {/* LG INSTRUCTIONS - Initially Show These grid.row on load....Hide only when <div className="table-container"> is at the top of the screen.,,, */}

                    {!this.state.isSticky && ( <>
                    <Grid.Row>
                        <Grid.Column>
                            {!!this.state.monthlyCost.length>0  && <MonthlyUtilityChart 
                                                             selectedRowKey={this.state.selectedRowKey}
                                                             data={this.state.monthlyCost} label={"Total Cost (£)"} title={"Monthly Utility Cost"} /> }
                        </Grid.Column>

                        <Grid.Column>
                            {!!this.state.monthlyCost.length>0  && <ConsumptionChart data={this.state.monthlyConsumption}
                                                             selectedRowKey={this.state.selectedRowKey}
                                                             /> }
                        </Grid.Column>

                        <Popup content='PLEASE NOTE -  this graph is created based on calculations for expected dates of 
                        invoice delivery to Inenco and upload to our database. Therefore the graph/s may not show the full last 
                        12 months of data-completeness. (e.g. a series line with quarterly supplier billing may be 
                        “missing” up to 3 months backwards from today’s date – this will still be deemed to be 100% data-complete).'  
                        position='left center' 
                        inverted 
                        trigger={
                        <Grid.Column>
                            {!!this.state.dataCompleteness.length > 0 &&
                             <MonthlyUtilityChart data={this.state.dataCompleteness} 
                                 title={"Data Completeness By Utility"} label={"Percentage Complete (%)"}
                                 selectedRowKey={this.state.selectedRowKey}

                             />
                            }
                        </Grid.Column>
                        }/>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column width={4}>
                            {!!(this.state.yearlyCost.electricity > 0 || this.state.yearlyCost.gas > 0 || this.state.yearlyCost.water > 0) &&
                            <YearlyDonutChart data={this.state.yearlyCost}
                            selectedRowKey={this.state.selectedRowKey}

                                              title={"Meter Sites Cost By Utlity (£) "}/>}
                        </Grid.Column>
                        <Grid.Column width={4}>
                            {!!(this.state.yearlyConsumptionDonut.electricity > 0 || this.state.yearlyConsumptionDonut.gas > 0 || this.state.yearlyConsumptionDonut.water > 0) &&
                            <YearlyDonutChart data={this.state.yearlyConsumptionDonut}
                              
                                selectedRowKey={this.state.selectedRowKey}
                            title={"Meter Sites Consumption By Utility (kWh)"}/>}
                        </Grid.Column>
                        <Grid.Column>
                            {!!this.state.sitesList.length > 0 && <MapComponent sites={this.state.sitesList}/>}
                        </Grid.Column>
                    </Grid.Row>
                 </> )}
                 </> }
                    <Grid.Row>
                        <Grid.Column>
                            <h2>Site List</h2>
                        </Grid.Column>
                        {this.state.params.meterReadMode === undefined &&
                        <Grid.Column>
                   
                   {(this.authServices.getCotsStatus() !== 'none') &&

                         <AddSiteModel></AddSiteModel>
                        } 
                        </Grid.Column>
    }
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <div ref={this.stickyRef} className="table-container">
                                {(this.props.customerId === 15592 || this.props.customerId === 355200) ?
                                <FilterableDatatable  dataProvider={this.state.dataProvider} name="sites" canExport={true} storeName="siteList" clearStore={ this.getStoreageRule() } 
                                                     contextData={{ customerId: this.props.customerId }} defaultSort={"locationId"}
                                                     headerComponent={SiteFundTableHeader}  rowComponent={(props) => <SiteFundTableRow {...props} 
                                                     selected={this.state.selectedRowKey === props.data.siteKey} 
                                                     onRowSelect={this.handleRowSelect} />}  /> 
                                                     :
                                <FilterableDatatable  dataProvider={this.state.dataProvider} name="sites" canExport={true} storeName="siteList" clearStore={ this.getStoreageRule() } 
                                                     contextData={{ customerId: this.props.customerId }} defaultSort={"locationId"}
                                                     headerComponent={SiteTableHeader}  rowComponent={(props) => <SiteTableRow {...props} 
                                                     selected={this.state.selectedRowKey === props.data.siteKey} 
                                                     onRowSelect={this.handleRowSelect} />}  /> 
                                }

                 
                            </div>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
            </div>
        );
    }

    handleDateChange(name, value) {
        this.setState({
            [name]: value
        });
    };
    componentDidMount = () => {
        this.context.addBreadcrumb({ title: 'Sites', path: '/sites' });


        this.throttledCheckSticky = throttle(this.checkSticky, 100);

        window.addEventListener('scroll', this.throttledCheckSticky);
        window.addEventListener('resize', this.throttledCheckSticky);
        
        //setTimeout(this.checkSticky, 100); // Delay to ensure the component is fully rendered
        
        

        ReactGA.pageview('site');
        this.props.history.listen(() => {
            // Detecting, user has changed URL
            console.info(this.props.history.location.pathname);

            window.history.replaceState(null, '') //Allows back button to work on stored Searches
                   });


        this.fetchData();
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.throttledCheckSticky);
        window.removeEventListener('resize', this.throttledCheckSticky);
        }

    setOpen = (open) => {
        if(open === false)
        {
            this.setState({
        
                showInfoHide : false,
                showErrorHide : true,
                showSuccessHide  : true,
            });
        }
        this.setState({
        
            meterModalOpen : open
        });
    }

   getStoreageRule() {
    try 
    {

       return  this.props.location.state.clearStore; // better way to check undefined but i'm going mad today
     } catch
      {
          return false
      }
   }

   // Add to Sites component

fetchDataForSite = (siteKey) => {
    api.getSitesCostConsumption(this.props.customerId, siteKey)
      .then((siteCostConsumption) => {
       

        this.setState({
          monthlyCost: collateUtilityData(siteCostConsumption, "cost"),
          monthlyConsumption: collateUtilityData(siteCostConsumption, "consumption"),
          dataCompleteness: collateUtilityData(siteCostConsumption, "dataCompleteness", defaultUtilities, x => (x*100).toFixed(2)),
          yearlyCost: sumUtilityData(siteCostConsumption, "cost"),
          yearlyConsumption: sumUtilityData(siteCostConsumption, "consumption"),
          yearlyConsumptionDonut : sumUtilityDataDonut(siteCostConsumption, "consumption")


            

        });
      });
  };
  
  resetData = () => {
    this.fetchData(); // Assuming fetchData() loads default graph data
  };
  
  handleRowSelect = (siteKey) => {
    if (this.state.selectedRowKey === siteKey) {
      this.setState({ selectedRowKey: null });
      this.resetData();
    } else {
      this.setState({ selectedRowKey: siteKey });
      this.fetchDataForSite(siteKey);
    }
  };
  

    fetchData = () => {
        return Promise.all([
         
            api.getMonthlyCostConsumption(),
        ])
        .then(([consumptionData]) =>
{
   
            this.setState({
                //sitesList :sitesList.data,
                //advancedFilters : sitesList.advancedFilters,
                
                monthlyCost: collateUtilityData(consumptionData, "cost"),
                monthlyConsumption: collateUtilityData(consumptionData, "consumption"),
                dataCompleteness: collateUtilityData(consumptionData, "dataCompleteness", defaultUtilities, x => (x*100).toFixed(2)),
                yearlyCost: sumUtilityData(consumptionData, "cost"),
                yearlyConsumption: sumUtilityData(consumptionData, "consumption"),
                yearlyConsumptionDonut : sumUtilityDataDonut(consumptionData, "consumption")
            })
        }
            )
    };
}

export default withRouter(Sites);